/**
 * airtec-filter-translations.js
 * Translates Search & Discovery filter values DE → FR on the French storefront.
 * Runs on initial load and after every AJAX filter update via MutationObserver.
 */
(function () {
  'use strict';

  // Only execute on the French locale
  // Prefer window.airtecLocale (set via localization.language.iso_code in theme.liquid)
  // Fallback to html[lang] for safety
  const _locale = window.airtecLocale || document.documentElement.lang;
  if (_locale !== 'fr') return;

  // ── Exact-match translation table ─────────────────────────────
  const EXACT = {
    // ── Anwendung ──────────────────────────────────────────────
    'Holz':       'Bois',
    'Heizöl':     'Mazout',
    'Gas':        'Gaz',
    'Pellets':    'Pellets',
    'Gaskamin':   'Cheminée à gaz',
    'Lüftung':    'Ventilation',
    'Luftzufuhr': "Amenée d'air",
    'KWL':        'VMC',
    // ── Oberfläche ─────────────────────────────────────────────
    'Glänzend':   'Brillant',
    'Matt':       'Mat',
    'Schwarz':    'Noir',
    // ── DW Subsystem (DW → DP) ─────────────────────────────────
    'DW 32.5 Inox matt':        'DP 32.5 Inox mat',
    'DW 32.5 Kupfer':           'DP 32.5 Cuivre',
    'DW 50 Inox matt':          'DP 50 Inox mat',
    'DW 50 Kupfer':             'DP 50 Cuivre',
    'DW VISION Inox gebürstet': 'DP VISION Inox brossé',
    'DW VISION Inox matt':      'DP VISION Inox mat',
    'DW VISION Kupfer':         'DP VISION Cuivre',
    // ── Steel Farbe (Airnox Steel) ─────────────────────────────
    'Airnox Steel schwarz':     'Airnox Steel noir',
    'Airnox Steel gussgrau':    'Airnox Steel gris fonte',
    // ── Produktart / Type de produit ───────────────────────────
    'AbAbdichtungsmanschette':                          "Manchette d'étanchéité",
    'Abdeckblende':                                     'Cache de finition',
    'Abdichtungsmanschette':                            "Manchette d'étanchéité",
    'Abgasklappe mit Drehantrieb für Aussenbereich':    'Clapet de fumée motorisé extérieur avec entraînement rotatif',
    'Abgasklappe mit Federrücklaufantrieb':             'Clapet de fumée avec retour à ressort',
    'Abgasklappe mit Handverstellung':                  'Clapet de fumée à réglage manuel',
    'Abgasklappe motorisch':                            'Clapet de fumée motorisé',
    'Abgasklappe motorisch Schnellläufer':              'Clapet de fumée motorisé rapide',
    'Abgasklappe motorisch für Aussenbereich':          'Clapet de fumée motorisé pour usage extérieur',
    'Abgasklappe motorisch mit Federrücklauf':          'Clapet de fumée motorisé avec retour à ressort',
    'Abgasklappe motorisch mit Federrücklaufantrieb':   'Clapet de fumée motorisé avec retour à ressort',
    'Abgasklappe motorisch mit Klappenantrieb':         'Clapet de fumée motorisé avec entraînement',
    'Abluftregenhut':                                   'Chapeau de ventilation',
    'Abschlussdeckel':                                  'Couvercle de fermeture',
    'Abspannschelle':                                   'Bride de haubanage',
    'Ankerplatte':                                      "Plaque d'ancrage",
    'Anschlusskabel':                                   'Câble de connexion',
    'Anschlussstutzen':                                 'Piquage',
    'Anschlussstück oval-rund':                         'Pièce de raccordement ovale-rond',
    'Aufhängung':                                       'Suspension',
    'Auflagebride mit Doppelschaft':                    'Bride intermédiaire',
    'Befestigungsschelle':                              'Collier de fixation',
    'Bodenplatte':                                      'Plaque de fond',
    'Bogen starr':                                      'Coude rigide',
    'Bogen variabel':                                   'Coude réglable',
    'Brandschutzmatte':                                 'Matelas coupe-feu',
    'Dacheinfassung':                                   'Garniture de toiture',
    'Deckel':                                           'Couvercle',
    'Deckendurchlauf':                                  'Passage de dalle',
    'Deckenfutterrohr':                                 'Manchette de passage de dalle',
    'Deckenfutterrohr mit Laschen':                     'Manchette de passage de dalle avec pattes',
    'Dehnfugenblech':                                   'Couvre-joint',
    'Dichtring':                                        "Joint d'étanchéité",
    'Dichtungsmasse':                                   "Mastic d'étanchéité",
    'Dila':                                             'Pièce de dilatation',
    'Dila eckig':                                       'Pièce de dilatation carrée',
    'Dila rund':                                        'Pièce de dilatation ronde',
    'Doppelfutterrohr':                                 'Manchette double',
    'Drosselklappe':                                    'Clapet de réglage',
    'Druckentlastungsklappe':                           'Soupape de limitation de pression',
    'EMPA':                                             'Tube EMPA',
    'Elektrode für Schornsteine grösser 300x300mm':     'Électrode pour grandes cheminées',
    'Entlüftungsgitter':                                'Grille de ventilation',
    'Erweiterung':                                      'Augmentation',
    'Etage':                                            'Étagère',
    'Feinstaubabscheider':                              'Filtre électrostatique',
    'Fussbodenauslass':                                 'Sortie de sol',
    'Gewinderohr':                                      'Tube fileté',
    'Gewindestange':                                    'Tige filetée',
    'Glasgewebeband':                                   'Bande en fibre de verre',
    'Gleitmittel':                                      'Lubrifiant',
    'Grundplatte':                                      'Plaque de base',
    'Grundplatte zur Befestigung':                      'Plaque de base pour fixation',
    'Hosenstück':                                       'Culotte',
    'Hängerahmen':                                      'Cadre suspendu',
    'Irisblende':                                       'Diaphragme Iris',
    'Isolationsschale alukaschiert':                    "Coquille d'isolation",
    'Jalousie':                                         'Clapet de surpression',
    'Joukowsky-Klappe':                                 'Clapet Joukowsky',
    'Kaminaufsätze':                                    'Finition de toiture',
    'Kaminfuss':                                        'Pied de cheminée',
    'Kaminhut':                                         'Cape de cheminée',
    'Kamintüre':                                        'Porte de ramonage',
    'Klebeband':                                        'Ruban adhésif',
    'Klebstoff':                                        'Colle',
    'Kondensatablauf':                                  'Écoulement de condensats',
    'Kondensatschale':                                  'Bac à condensats',
    'Konsole für Zwischendecke':                        'Console pour faux plafond',
    'Kopfabdeckung belüftet':                           'Couvre-joint ventilé',
    'Kopfabdeckung mit Wetterkragen':                   'Couvre-joint avec collerette',
    'Kraftanschlussmanschette':                         'Manchette de raccordement forcé',
    'Kreuzstück':                                       'Pièce en croix',
    'LCD-Anzeige für Innenbereich':                     'Écran LCD intérieur',
    'Lochgitter':                                       'Grille perforée',
    'Luftmengenregulierer':                             "Régulateur de débit d'air",
    'Luftverteilkasten':                                "Boîte de distribution d'air",
    'Mantel':                                           'Manteau de finition',
    'Maschengitter':                                    'Grille à maille',
    'Mengeneinstellsatz':                               'Kit de réglage de débit',
    'Messelement':                                      'Élément de mesure',
    'Montagehilfe':                                     'Aide au montage',
    'Montagepaste':                                     'Pâte de montage',
    'Montageschelle / Zentrierbride':                   'Bride de centrage',
    'Montageschelle|Zentrierbride':                     'Bride de centrage',
    'Mörtel':                                           'Mortier',
    'Mündungsabschluss':                                'Cône de finition',
    'Neutralisationsbox':                               'Box de neutralisation',
    'Platten':                                          'Plaques',
    'Pumpe zu Ableitung von Kondensat':                 "Pompe d'évacuation des condensats",
    'Quadratisch':                                      'Carré',
    'Rauchsauger':                                      'Extracteur de fumée',
    'Reduzierung':                                      'Réduction',
    'Regenhaube':                                       'Cape pare-pluie',
    'Reinigsungstüre':                                  'Porte de ramonage',
    'Revisionsdeckel gross für Russpartikelfilter':     'Grand couvercle pour filtre à particules de suie',
    'Revisionselement':                                 "Élément d'inspection",
    'Rohr flexibel':                                    'Tube flexible',
    'Rohr starr':                                       'Tube rigide',
    'Russpartikelfilter für Mauerwerk inkl. Steuerung': 'Filtre à particules pour maçonnerie avec contrôle',
    'Russtopf':                                         'Sac à suie',
    'Rückstauklappe':                                   'Clapet anti-retour',
    'Rückströmsicherung':                               'Clapet anti-retour (protection contre reflux)',
    'SKOF':                                             'Console SKOF',
    'Schachtelement':                                   'Gaine technique',
    'Schalldämpfer':                                    'Amortisseur de bruit',
    'Schalldämpfer flexibel':                           'Amortisseur de bruit flexible',
    'Schalldämpfer starr':                              'Amortisseur de bruit rigide',
    'Schiebeelement':                                   'Tube télescopique',
    'Schlauch':                                         'Tuyau flexible',
    'Schlitzschieber':                                  'Grille à fentes',
    'Schraube':                                         'Visserie',
    'Schrauben':                                        'Vis',
    'Sicherheitstemperaturbegrenzer':                   'Limiteur de température de sécurité',
    'Siphon':                                           'Siphon',
    'Spezifika (kontextspezifisch)':                    'Pièce spéciale',
    'Spray':                                            'Spray',
    'Statische Konsole 90°':                            'Console de support à 90°',
    'Statusanzeige für Innenbereich':                   "Indicateur d'état intérieur",
    'Stopfwolle':                                       'Laine de roche',
    'Strahlungsschutz':                                 'Protection contre les rayonnements',
    'Streckmetallgitter':                               'Grille métal déployé',
    'T-Stück':                                          'Té',
    'Tellerventil':                                     'Soupape',
    'Terminal':                                         'Terminal',
    'Ventilatorgitter':                                 'Grille de ventilateur',
    'Ventilatorgitter / Zu- und Abluftgitter':          "Grille d'amenée et d'évacuation d'air",
    'Verbindungselement':                               'Élément de connexion',
    'Vermiculite':                                      'Vermiculite',
    'Versatz':                                          'Déviation',
    'Viton-Zapfen':                                     'Pivot en viton',
    'Wand-/Deckenblende':                               'Rosace de finition',
    'Wand-/Deckenblende eckig':                         'Rosace de finition carrée',
    'Wand-/Deckenblende rund':                          'Rosace de finition ronde',
    'Wandauslass':                                      'Sortie murale',
    'Wandhalter':                                       'Support mural',
    'Wandkonsole':                                      'Console murale',
    'Wartungsschalter':                                 "Interrupteur d'entretien",
    'Wetterkragen / Wandrosette':                       'Collerette / Rosace murale',
    'Wetterschutzgitter':                               'Grille pare-pluie',
    'Zugklappe':                                        'Clapet de tirage',
    'Zugregler':                                        'Régulateur de tirage',
    'Zuluftelement':                                    "Élément d'amenée d'air",
    'Zwischenhalterung':                                'Support intermédiaire',
    'Zwischenstütze':                                   'Support coulissant',
    'Übergang':                                         'Raccord de transition',
  };

  // Regex for Materialstärke partial replacements
  const PARTIAL = [
    [/\bbis\b/g,  "jusqu'à"],
    [/\bab\b/g,   'à partir de'],
  ];

  function translateString(text) {
    const trimmed = text.trim();
    // 1. Exact match
    if (EXACT[trimmed] !== undefined) {
      return text.replace(trimmed, EXACT[trimmed]);
    }
    // 2. Partial (Materialstärke words)
    let result = text;
    PARTIAL.forEach(([pattern, replacement]) => {
      result = result.replace(pattern, replacement);
    });
    return result;
  }

  // Translate direct text nodes inside an element (skips child elements like SVG).
  // Active filter pills render as "Filter-Label: Wert" in ONE text node
  // (facets.liquid: {{ filter.label }}: {{ value.label }}). The label already comes
  // translated from Shopify, the value does not — so look up only the part after the
  // first ": ". Without the split nothing matches the dictionary and the pill stays German.
  function translateTextNodes(el) {
    el.childNodes.forEach(node => {
      if (node.nodeType !== Node.TEXT_NODE || !node.textContent.trim()) return;
      const raw = node.textContent;
      const trimmed = raw.trim();
      const sep = trimmed.indexOf(': ');
      let translated;
      if (sep > -1) {
        const label = trimmed.slice(0, sep);
        const value = trimmed.slice(sep + 2);
        translated = raw.replace(trimmed, label + ': ' + translateString(value));
      } else {
        // e.g. price-range pills, which carry no filter label
        translated = translateString(raw);
      }
      if (translated !== raw) node.textContent = translated;
    });
  }

  // Guard flag to prevent MutationObserver ↔ DOM-write infinite loops
  let busy = false;

  function translateAll() {
    if (busy) return;
    busy = true;

    // 1. Filter checkbox labels  (desktop + mobile drawer)
    document.querySelectorAll('.facet-checkbox__text-label').forEach(el => {
      const original = el.textContent.trim();
      const translated = EXACT[original] ?? translateString(original);
      if (translated !== original) el.textContent = translated;
    });

    // 2. Active filter pill buttons
    document.querySelectorAll('.active-facets__button-inner').forEach(el => {
      translateTextNodes(el);
    });

    // 3. Subcategory nav tile labels (DW → DP buttons on collection pages)
    document.querySelectorAll('.b2b-subcategory-nav__label').forEach(el => {
      const original = el.textContent.trim();
      const translated = EXACT[original] ?? translateString(original);
      if (translated !== original) el.textContent = translated;
    });

    requestAnimationFrame(() => { busy = false; });
  }

  // ── Initial run ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateAll);
  } else {
    translateAll();
  }

  // ── Watch for AJAX filter re-renders ──────────────────────────
  // Dawn replaces inner HTML of these containers after AJAX calls
  const WATCH_SELECTORS = [
    '#FacetsWrapperDesktop',
    '.mobile-facets__list',
    '.active-facets',
    '#main-collection-filters', // search page
  ];

  function attachObserver() {
    WATCH_SELECTORS.forEach(sel => {
      const el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(translateAll)
        .observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

})();
